var map = {
	"./avatar-leila-base-full.png": 87639,
	"./avatar-leila-fall-full.png": 16259,
	"./avatar-leila-spring-full.png": 37683,
	"./avatar-leila-summer-full.png": 68339,
	"./avatar-leila-travel-full.png": 89970,
	"./avatar-leila-winter-full.png": 16463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55786;